;(function () {
  'use strict'

  angular.module('contrast.auth').factory('FeaturesFactory', FeaturesFactory)

  function FeaturesFactory($http) {
    'ngInject'

    return {
      getFeaturesByKeys,
      getFeatures,
      getAgentFeatures,
      getOssInventoryFeature,
      getOssFeature,
      getHarmonyFeature,
      getSastFeature
    }

    function getFeaturesByKeys(keys) {
      return $http.get('/Contrast/api/ng/feature/flags/' + keys.join(','))
    }

    function getFeatures() {
      return $http.get('/Contrast/api/ng/feature/flags')
    }

    function getAgentFeatures() {
      return $http.get('/Contrast/api/ng/agent/feature')
    }

    function getOssInventoryFeature(orgUuid) {
      return $http.get(
        '/Contrast/api/ng/' + orgUuid + '/feature/oss-inventory-mode'
      )
    }

    function getOssFeature(orgUuid) {
      return $http.get('/Contrast/api/ng/' + orgUuid + '/feature/oss')
    }

    function getHarmonyFeature(orgUuid) {
      return $http.get('/Contrast/api/ng/' + orgUuid + '/feature/harmony')
    }

    function getSastFeature(orgUuid) {
      return $http.get('/Contrast/api/ng/' + orgUuid + '/feature/sast')
    }
  }
})()
